import { createSimulateMessage as createSimulateEVMMessage } from '@exodus/web3-ethereum-utils'
import assert from 'minimalistic-assert'

export const createSimulateMessage = ({ asset }) => {
  assert(asset, '"asset" should be passed.')

  const simulateEVMMessage = createSimulateEVMMessage()

  return function simulateMessage({ message, ...restParameters }) {
    return simulateEVMMessage({ asset, message, ...restParameters })
  }
}
